import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import GradientCard from "components/Common/GradientCard";
import CommunityStats from "components/Home/CommunityStats";

interface UserFeedbackTileProps {
  businessOverallStats: BusinessOverallStatsType | null;
  isPlanActive: boolean;
}
const UserFeedbackTiles: React.FC<UserFeedbackTileProps> = ({
  businessOverallStats: feedback,
  isPlanActive,
}) => {
  return (
    <div className="flex md:flex-row flex-col gap-6">
      {/* Left card - Positive Influence stats */}
      <GradientCard
        topBorderColor="yellow"
        sideGradientColors={{ from: "#FEBF4C", to: "#FF6A00" }} 
        className="md:w-1/2 w-full h-full"
      >
        <div className="min-h-[200px]  p-6 flex flex-col justify-center">
          <div className="text-4xl font-bold text-black mb-4">
            {feedback?.positiveInfluence}%
          </div>
          <div className="text-base text-gray-800 leading-relaxed">
            of users have indicated that Open Rewards positively influenced their decision to shop local.
          </div>
        </div>
      </GradientCard>
      
      {/* Right card - Community stats */}
      <CommunityStats businessOverallStats={feedback} />
    </div>
  );
};

export default UserFeedbackTiles;
